import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getSocialMediaProviderProfiles, getSocialProfiles } from "./actions";

export const socialProfileAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = socialProfileAdapter.getInitialState({});

export const socialProfileSlice = createSlice({
  name: "socialProfile",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSocialProfiles.fulfilled, (state, action) => {
      if (!action.payload.error) {
        socialProfileAdapter.setAll(state, action.payload.data);
      } else {
        socialProfileAdapter.setAll(state, []);
      }
    });
    builder.addCase(getSocialMediaProviderProfiles.fulfilled, (state, action) => {
      if (!action.payload.error) {
        socialProfileAdapter.setAll(state, action.payload.data);
      } else {
        socialProfileAdapter.setAll(state, []);
      }
    });
  },
});

export default socialProfileSlice.reducer;
